import OwlCarousel from 'react-owl-carousel-autoheight';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import { useEffect, useRef, useState } from 'react';
import ResCon from '../Extra/Rescon';

const LineStyle = ((props) => {

    const CarouselRef = useRef();

    const [results, setResults] = useState([]);

    const [carouselReady, setCarouselReady] = useState(false);

    const [mounted, setMounted] = useState(false);


    useEffect(() => {
        setResults(props.result);
        setMounted(true);
    }, [props]);

    useEffect(() => {

        if (!carouselReady) return;
        setTimeout(() => {
            CarouselRef.current.to(1, 0);
            CarouselRef.current.to(0, 0);
        }, 500);

    }, [carouselReady]);

    if (!mounted) return;

    return (
        <>
            <div className="result-wrapper mt-5">
                <Tabs changeTabs={(val) => {
                    CarouselRef.current.to(val, 500);
                }} />
                <OwlCarousel
                    ref={slider => (CarouselRef.current = slider)}
                    onInitialize={() => setCarouselReady(true)}
                    className='owl-theme'
                    loop={false}
                    margin={10}
                    nav={false}
                    dots={false}
                    items={1}
                    touchDrag={false}
                    autoHeight={true}
                    mouseDrag={false}>
                    <div className='item'>
                        <LineTable count={10} data={results} />
                    </div>
                    <div className='item'>
                        <LineTable count={9} data={results} />
                    </div>
                    <div className='item'>
                        <LineTable count={8} data={results} />
                    </div>
                    <div className='item'>
                        <LineTable count={7} data={results} />
                    </div>
                    <div className='item'>
                        <LineTable count={6} data={results} />
                    </div>
                    <div className='item'>
                        <LineTable count={5} data={results} />
                    </div>
                    <div className='item'>
                        <LineTable count={4} data={results} />
                    </div>
                    <div className='item'>
                        <LineTable count={3} data={results} />
                    </div>
                    <div className='item'>
                        <LineTable count={2} data={results} />
                    </div>
                    <div className='item'>
                        <LineTable count={1} data={results} />
                    </div>
                </OwlCarousel>
            </div>
        </>
    )
});

const Tabs = ((props) => {

    const [selected, setSelected] = useState(0);

    const ChangeSection = ((val) => {
        setSelected(val)
        props.changeTabs(val);
    });


    return (
        <>
            <ul className="game-result-header">
                <li className={`c-pointer ${selected == 0 && 'active'}`} onClick={() => ChangeSection(0)}>10매</li>
                <li className={`c-pointer ${selected == 1 && 'active'}`} onClick={() => ChangeSection(1)}>9매</li>
                <li className={`c-pointer ${selected == 2 && 'active'}`} onClick={() => ChangeSection(2)}>8매</li>
                <li className={`c-pointer ${selected == 3 && 'active'}`} onClick={() => ChangeSection(3)}>7매</li>
                <li className={`c-pointer ${selected == 4 && 'active'}`} onClick={() => ChangeSection(4)}>6매</li>
                <li className={`c-pointer ${selected == 5 && 'active'}`} onClick={() => ChangeSection(5)}>5매</li>
                <li className={`c-pointer ${selected == 6 && 'active'}`} onClick={() => ChangeSection(6)}>4매</li>
                <li className={`c-pointer ${selected == 7 && 'active'}`} onClick={() => ChangeSection(7)}>3매</li>
                <li className={`c-pointer ${selected == 8 && 'active'}`} onClick={() => ChangeSection(8)}>2매</li>
                <li className={`c-pointer ${selected == 9 && 'active'}`} onClick={() => ChangeSection(9)}>1매</li>
            </ul>
        </>
    )
});

const LineTable = ((props) => {

    let len = props.count;

    const [container, setContainer] = useState([]);
    const [selected, setSelected] = useState(0);

    const tableRef = useRef();

    useEffect(() => {
        SortData(props.data);
    }, [props.data]);

    const SortData = ((data) => {

        let cont = [];
        let MainCont = [];
        let counter = 0;

        data.map((item) => {

            cont.push(item);
            counter++;

            if (counter == len) {
                MainCont.push(cont);
                cont = [];
                counter = 0;
            }
        });

        if (cont.length != 0) {
            MainCont.push(cont);
        }

        setContainer(MainCont);
    });

    useEffect(() => {
        tableRef.current.scrollLeft = (container.length * 50);
    }, [props, container])

    return (
        <>
            <ul className='line-res-type'>
                <li onClick={() => { if (selected == 0) return; setSelected(0) }}><CheckIcon type={`${selected == 0 ? 'on' : 'off'}`} /> 좌우패턴</li>
                <li onClick={() => { if (selected == 1) return; setSelected(1) }}><CheckIcon type={`${selected == 1 ? 'on' : 'off'}`} /> 줄수패턴</li>
                <li onClick={() => { if (selected == 2) return; setSelected(2) }}><CheckIcon type={`${selected == 2 ? 'on' : 'off'}`} /> 홀짝 패턴</li>
            </ul>
            <div className='res-main-wrapper' ref={tableRef}>
                <div className='result-table-wrapper' style={{ width: (container.length * 50) + 'px' }}>
                    {container.map((item, index) => (
                        <div className="res-cont" key={index}>
                            {item.map((i, x) => (
                                <div className="child-cont" key={x}>

                                    {selected == 0 && <ResCon type={i['ball_1'] % 2 == 0 ? 'r' : 'b'} text={i.round} />}
                                    {selected == 1 && <ResCon type={i['ball_1'] <= 14 ? 'b' : 'r'} text={i.round} />}
                                    {selected == 2 &&
                                        <>
                                            {(i['ball_1'] % 2 != 0 && i['ball_1'] <= 14) && <ResCon type={"r"} text={i.round} />}
                                            {(i['ball_1'] % 2 == 0 && i['ball_1'] <= 14) && <ResCon type={"b"} text={i.round} />}
                                            {(i['ball_1'] % 2 != 0 && i['ball_1'] > 14) && <ResCon type={"b"} text={i.round} />}
                                            {(i['ball_1'] % 2 == 0 && i['ball_1'] > 14) && <ResCon type={"r"} text={i.round} />}

                                        </>
                                    }
                                </div>
                            ))}

                            {(container.length - 1) == index &&
                                <>
                                    {
                                        item.length != 0 && <>
                                            {CreateEmptyBox((len - item.length))}
                                        </>
                                    }
                                </>
                            }
                            {(item.length) != 0 && <div className="child-cont">{index + 1}</div>}

                        </div>
                    ))}

                </div>
            </div>
        </>
    )
});

const CreateEmptyBox = ((count) => {

    let content = [];
    for (let i = 0; i < count; i++) {

        content.push(<div className="child-cont" key={i}></div>);
    }
    return content;
});




const CheckIcon = ((props) => {
    return (
        <>
            {props.type == 'on' && <img src="icon/on.png" />}
            {props.type == 'off' && <img src="icon/off.png" />}
        </>
    )
})
export default LineStyle;